export default {"src":"/_next/static/media/table-loader.57ef799d.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};